module.exports = __webpack_public_path__ + "img/jm.fe4f5fb8.svg";